(function () {
  var requestId = 0;

  function carsLabel(n) {
    var mod10 = n % 10;
    var mod100 = n % 100;
    var word = 'vozů';
    if (n === 1) word = 'vůz';
    else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) word = 'vozy';
    return n + ' ' + word;
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function kc(cents) {
    var amount = Math.round(Number(cents) / 100);
    return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function modelHref(gid, paramName) {
    var url = new URL(window.location.href);
    var drop = [];
    url.searchParams.forEach(function (_, key) {
      if (key === 'page' || key === 'section_id' || key === 'view' || key.indexOf('car_model') !== -1) drop.push(key);
    });
    drop.forEach(function (key) {
      url.searchParams.delete(key);
    });
    url.searchParams.set(paramName || 'filter.p.m.custom.car_model', gid);
    return url.pathname + '?' + url.searchParams.toString();
  }

  function specText(model) {
    return [model.types, model.fuels].filter(Boolean).join(', ');
  }

  function topPhrase(models) {
    var names = models
      .slice(0, 3)
      .map(function (model) {
        return model.name || model.title;
      })
      .filter(Boolean);
    if (names.length < 2) return names[0] || '';
    if (names.length === 2) return names[0] + ' a ' + names[1];
    return names[0] + ', ' + names[1] + ' a ' + names[2];
  }

  function rowHtml(model, paramName) {
    var title = model.title || [model.make, model.name].filter(Boolean).join(' ');
    var priceWithout = model.price_text || kc(model.price);
    var priceWith = kc(Math.round((Number(model.price) / 100) * 1.21) * 100);
    return (
      '<tr data-count="' +
      esc(model.count) +
      '" data-model="' +
      esc(model.name || title) +
      '"><th scope="row"><a href="' +
      esc(modelHref(model.gid, paramName)) +
      '">' +
      esc(title) +
      '</a></th><td>' +
      esc(specText(model)) +
      '</td><td class="brand-table__num">' +
      esc(carsLabel(model.count || 0)) +
      '</td><td><span class="withoutVat">' +
      esc(priceWithout) +
      ' Kč</span><span class="withVat">' +
      esc(priceWith) +
      ' Kč</span></td></tr>'
    );
  }

  function fillLegal(root, models) {
    var legal = root.querySelector('[data-brand-table-legal]');
    if (!legal) return;
    var template = root.getAttribute('data-legal') || '';
    var sorted = models.slice().sort(function (a, b) {
      return (b.count || 0) - (a.count || 0);
    });
    legal.textContent = template.replace('{top_models}', topPhrase(sorted));
  }

  function modelsFromDom(root) {
    return [...root.querySelectorAll('tbody tr')].map(function (row) {
      return {
        name: row.getAttribute('data-model') || '',
        title: row.getAttribute('data-model') || '',
        count: Number(row.getAttribute('data-count') || 0),
      };
    });
  }

  function mergeModels(rows) {
    var order = [];
    var map = {};
    rows.forEach(function (row) {
      if (!row || !row.models) return;
      row.models.forEach(function (model) {
        if (!model || !model.id) return;
        var current = map[model.id];
        if (!current) {
          map[model.id] = model;
          order.push(model.id);
          return;
        }
        current.count += model.count || 0;
        if (model.price != null && (current.price == null || model.price < current.price)) {
          current.price = model.price;
          current.price_text = model.price_text;
        }
        ['types', 'fuels', 'trims'].forEach(function (key) {
          var next = (model[key] || '').split(', ').filter(Boolean);
          var have = (current[key] || '').split(', ').filter(Boolean);
          next.forEach(function (part) {
            if (have.indexOf(part) === -1) have.push(part);
          });
          current[key] = have.join(', ');
        });
      });
    });
    return order.map(function (id) {
      return map[id];
    });
  }

  function refreshBrandTable() {
    var root = document.querySelector('[data-brand-table]');
    if (!root) return;
    var body = root.querySelector('[data-brand-table-body]');
    if (!body) return;
    fillLegal(root, modelsFromDom(root));

    var total = Number(root.getAttribute('data-models-total') || 0);
    if (total < 1) return;
    var id = (requestId += 1);
    var pages = Math.max(1, Math.ceil(total / 50));
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.set('view', 'brand-models');

    var jobs = [];
    for (var page = 1; page <= pages; page += 1) {
      params.set('page', String(page));
      jobs.push(
        fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            return null;
          }),
      );
    }

    Promise.all(jobs).then(function (rows) {
      if (id !== requestId || !root.isConnected) return;
      var models = mergeModels(rows).filter(function (model) {
        return model && model.price != null && model.count > 0;
      });
      if (!models.length) return;
      models.sort(function (a, b) {
        return (a.price || 0) - (b.price || 0);
      });
      var paramName = root.getAttribute('data-model-param') || 'filter.p.m.custom.car_model';
      body.innerHTML = models
        .map(function (model) {
          return rowHtml(model, paramName);
        })
        .join('');
      fillLegal(root, models);
    });
  }

  window.refreshBrandTable = refreshBrandTable;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshBrandTable);
  } else {
    refreshBrandTable();
  }
})();
